(() => {
  if (window.__cmQuoteBound) {
    return;
  }
  window.__cmQuoteBound = true;

  const SPINNER_ICON = `
    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
    </svg>
  `;

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-cm-quote-btn]");
    if (!btn) {
      return;
    }

    const apiUrl = btn.dataset.apiUrl;
    if (!apiUrl) {
      return;
    }

    const payloadEl = document.querySelector("[data-cm-quote-payload]");
    if (!payloadEl) {
      return;
    }

    const payload = JSON.parse(payloadEl.textContent);

    btn.dataset.label = btn.textContent.trim();
    btn.disabled = true;
    btn.innerHTML = SPINNER_ICON;

    try {
      const res = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `Request failed: ${res.status}`);
      }

      const json = await res.json();
      const viewUrl = json?.data?.viewUrl;
      if (!viewUrl) {
        throw new Error("Invalid response from server");
      }

      // Navigate current tab to the PDF view
      window.location.href = viewUrl;
    } catch (err) {
      console.error("Quote request failed:", err);
      alert("Sorry, we could not generate your quote. Please try again.");
      restoreButton(btn);
    }
  });

  function restoreButton(btn) {
    if (btn.dataset.label == null) {
      return;
    }
    btn.textContent = btn.dataset.label;
    delete btn.dataset.label;
    btn.disabled = false;
  }

  window.addEventListener("pageshow", () => {
    document.querySelectorAll("[data-cm-quote-btn]").forEach(restoreButton);
  });
})();
